<template>
  <div class="phone-yk-home-shor-answer-wrapper">
    <el-form ref="formOption"
             label-position="left">
      <el-form-item label="题目：">
        <div v-if="IsTitle">
          <Editor placeholder="请输入内容" />
        </div>
        <div v-else>
          <span class="yk-multiselect-question"
                v-html="data.Content"></span>
        </div>
      </el-form-item>
      <el-form-item label="题目附件：" v-if="filesList.length > 0">
          <div v-if="IsTitle">
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
          <div v-else>
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
      </el-form-item>
      <el-form-item label="答案：">
        <!-- <Editor v-if="IsAnswers > 0" placeholder="请输入内容" v-model="content[0]" :config="config"/> -->
        <span v-for="item in data.Answers"
              :key="item"
              v-html="item"></span>
      </el-form-item>
      <el-form-item label="解析："
                    v-if="showThisAnswer">
        <!-- <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" /> -->
        <div>
          <span v-html="data.Analysis"></span>
        </div>
      </el-form-item>
      <el-form-item label="解析附件："
          v-if="showThisAnswer && analysisFilesList.length > 0">
          <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
      </el-form-item>
    </el-form>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="anaShow">
      <i class="el-icon-arrow-up"></i>
      <span>收起解析</span>
    </div>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="!anaShow">
      <i class="el-icon-arrow-down"></i>
      <span>查看解析</span>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/phoneQuestionFileNew.vue';
export default {
  name: 'short-answer',
  components: {
    QuestionFile
  },
  props: {
    isBook:{
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Boolean,
      default: true
    },
    IsAnswers: {
      type: Number,
      default: 0
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      showThisAnswer: true,
      anaShow: true,
      content: [],
      formOption: {
        choice: null
      },
      config: {
        events: {
          'froalaEditor.contentChanged': () => {
            this.doCheckValue();
          }
        }
      }
    };
  },
  created() {
    if (this.data.Answers) {
      this.content = this.data.Answers;
    }
    // 题目附件
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  },
  methods: {
    upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 做作业是选择答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.data.Id,
        Answers: this.content
      });
    }
  }
};
</script>
<style lang="scss">
@import '~theme/page/components/variables.scss';
.phone-yk-home-shor-answer-wrapper {
  position: relative;
  padding: 0 20px;
  background: #fff;
  .el-form-item {
    margin-bottom: 20px;
    .el-form-item__label {
      color: black;
    }
    .el-form-item__content {
      font-size: 14px;
      line-height: 36px;
      color: black;
      margin-left: 30px !important;
    }
  }
  .yk-multiselect-question {
    display: inline-block;
    
    p {
      display: inline-block;
      margin: 0;
      padding: 0;
    }
  }
  .yk-mm-up-down-wrapper {
    position: absolute;
    width: 240px;
    height: 30px;
    background: #f5f5f5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    bottom: -50px;
    left: 50%;
    margin-left: -120px;
    border-radius: 0 0 30px 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>
